import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const StyledFooter = styled.footer`
  position: relative;
  padding-top: 6rem;
  font-size: 1.8rem;
  color: white;
  background-color: black;

  a {
    transition: color 0.2s;
  }

  a:hover,
  a:focus-visible {
    color: rgba(255, 255, 255, 0.8);
  }
`

export const Links = styled.ul`
  margin: -2em 0 3.5rem;
  padding: 0;
  text-align: center;
  list-style: none;
  font-size: 1.5rem;

  ${mq.medium} {
    margin-block: 0 5rem;

    li {
      display: inline;
      font-size: 1.4rem;
      margin-block: 0 5rem;
    }
  }

  li {
    display: block;
    padding: 1em 3em;

    ${mq.medium} {
      display: inline;
      padding: 0 1em;
    }
  }
`

export const Logo = styled.img`
  display: block;
  width: 76rem;
  max-width: 100%;
  margin: 5rem auto 0;
  filter: brightness(100);
`
